// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// import App from './App'
const App = () => import("@/App");
import router from "./router";
import vueAxios from "vue-axios";
import axios from "axios";
import { Toast } from "mint-ui";

// Vue.prototype.$ju=$
Vue.use(vueAxios, axios);
import store from "./store/index.js"; //vuex
//复制粘贴插件
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// 转盘抽奖插件
import VueLuckyCanvas from "@lucky-canvas/vue";
Vue.use(VueLuckyCanvas);

// 二维码生成
import VueQriously from "vue-qriously";
Vue.use(VueQriously);

import "./static/js/vantUi.js";
import "./static/js/mintUi.js";

// 游戏配置
// import {gameConfig} from '@/static/js/gameConfig.js'
// Vue.prototype.$gameConfig = gameConfig

import md5 from "js-md5";
import publicJS from "./static/js/public.js";
Vue.use(publicJS);
import wzSDK from "./static/js/wzSDK.js";
Vue.use(wzSDK);
import Api from "./static/js/api.js";
import Axios from "@/static/js/request.js";
import Teleport from "./components/hongbao_new/common/telelop.vue";
import noData from "./components/hongbao_new/common/no_data.vue";
import noDataHor from "@/components/hor_redbag/common/no_data.vue";

Vue.component("Teleport", Teleport);
Vue.component("noData", noData);
Vue.component("noDataHor", noDataHor);
Vue.prototype.$Api = Api;
Vue.prototype.$Axios = Axios;
/**
 * 支付类型转换
 * @params {params} = [object] 需要转换的数据类型
 * @params { that } = [Object] 当前环境指向
 * @return any 当前返回的转换后数据
 * */
Vue.prototype.$PayConvert = function (params, that) {
  let wechat_pay_type =
    that.$store.getters.Stror_Get_BoxChannel.wechat_pay_type || 0; // 微信定义
  let ali_pay_type = that.$store.getters.Stror_Get_BoxChannel.ali_pay_type || 0; // 支付宝定义
  console.log(wechat_pay_type, ali_pay_type, "--ali_pay_type--");
  if (wechat_pay_type && wechat_pay_type != 0) {
    // 开启强制转换微信支付类型
    if (params.pay_type == 2) {
      params.pay_type = wechat_pay_type;
    }
  }
  if (ali_pay_type && ali_pay_type != 0) {
    // 开启强制转换支付宝支付类型
    if (params.pay_type == 3) {
      params.pay_type = ali_pay_type;
    }
  }
  return params;
};
/**
 * 支付路径设置
 * @params {data} = [object] 支付参数
 * @params {successBack} = [function] 成功回调
 * @params {errorBack} = [function] 失败回调
 */

Vue.prototype.$PayRoute = function (data, successBack, errorBack) {
  if (!data.pay_data) {
    Toast("支付异常，请稍后再试");
    errorBack && errorBack();
    return;
  }
  let framebox = "";
  let type = 0; // 是否是 创建的 iframe
  let isAliPay = 0; // 是否支付宝支付
  if (document.getElementById("iframePay_box")) {
    framebox = document.getElementById("iframePay_box");
  } else {
    framebox = document.createElement("iframe");
    framebox.id = "frameboxsss";
    type = 1;
  }

  let payurl = ""; // 支付的链接

  if (data.order.pay_type == 2) {
    // 2为微信app支付
    // 设置微信支付中转页
    if (data.order.pay_domain) {
      payurl = `${data.order.pay_domain}?payUrl=${encodeURIComponent(
        data.pay_data
      )}`;
    } else {
      payurl = data.pay_data;
    }
    // framebox.src = payurl
  } else if (data.order.pay_type == 3) {
    // 3为支付包
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    isAliPay = 1;
  } else if (data.order.pay_type == 16) {
    // 富有微信支付
    // }else if(isOpenFy){ // 是否开启富友支付
    console.log("开启富友支付---");
    // 设置微信支付中转页
    payurl = data.pay_data.token_url;
  } else if (data.order.pay_type == 17) {
    // 富友为支付包
    //判断是SAFARI时用这个
    payurl = data.pay_data.token_url;
    // location.href = data.pay_data.token_url
    isAliPay = 1;
  } else if (data.order.pay_type == 18) {
    // 趣智联微信支付
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    // location.href = data.pay_data.token_url
  } else if (data.order.pay_type == 19) {
    // 趣智联支付包
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    // location.href = data.pay_data.token_url
    isAliPay = 1;
  } else if (data.order.pay_type == 20) {
    // 快钱微信
    payurl = data.pay_data;
    this.app.BlindBoxherf(payurl);
    return;
    // location.href = data.pay_data.token_url
  } else if (data.order.pay_type == 21) {
    // 快钱支付宝
    payurl = data.pay_data;
    this.app.BlindBoxherf(payurl);
    return;
    // location.href = data.pay_data.token_url
    // isAliPay = 1
  } else if (data.order.pay_type == 24) {
    // 精秀微信支付
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    // location.href = data.pay_data.token_url
  } else if (data.order.pay_type == 25) {
    // 精秀支付宝支付
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    // location.href = data.pay_data.token_url
    isAliPay = 1;
  } else if (data.order.pay_type == 26) {
    // 星酷支付宝支付
    //判断是SAFARI时用这个
    payurl = data.pay_data;
    // location.href = data.pay_data.token_url
    isAliPay = 1;
  } else if (data.order.pay_type == 29) {
    // 微信 趣智联-易宝

    payurl = data.pay_data;
  } else if (data.order.pay_type == 30) {
    // 微信扫描支付
    if (data.order.pay_price >= 500 || data.order.pay_price < 1) {
      Toast("当前金额请用其他支付");
      return;
    }
    this.EventBus.$emit("wxqrcodepay", data.pay_data);
    // payurl = data.pay_data
    return;
  } else if (data.order.pay_type == 31) {
    // 微信 米花

    payurl = data.pay_data;
  }else if (data.order.pay_type == 32) {
    // 腾春 微信H5

    payurl = data.pay_data;
  }
  console.log("payurl----", payurl);
  framebox.src = payurl;
  if (isAliPay) {
    framebox.style = `
      width: 100vw;
      height: 100vh;
      position: fixed;
      left: 0;
      top: 0;
      z-index:99;
    `;
  } else {
    framebox.style = `
      width: 100vw;
      height: 100vh;
      position: fixed;
      left: -100vw;
      top: 0;
      display:block;
    `;
  }
  if (type == 1) {
    document.body.appendChild(framebox);
  }
  successBack && successBack();
  let tst = setTimeout(() => {
    clearTimeout(tst);
    if (type) {
      document.body.removeChild(framebox);
    } else {
      framebox.src = "";
      framebox.style = `
        display:none;
      `;
    }
  }, 5000);
};

// 设置event bus 同时挂载到全局window上
Vue.prototype.EventBus = new Vue();
window.EventBus = Vue.prototype.EventBus;
console.log("1102 回退版本后 新增point");
//接收 window.postMessage的消息
window.addEventListener("message", function (e) {
  var u = navigator.userAgent;
  var _this = this;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // console.log("sdk-center window.postMessage的1111消息 e.data = ", e.data);
  if (typeof e.data != "string") return;
  var re = JSON.parse(e.data);
  // console.log('message->re:',re,typeof re)
  if (typeof re == "string") re = JSON.parse(re);
  console.log("message->re:", re, typeof re);
  var action = re.type;
  fromBoxMessage(action); // 触发盒子消息
  if (isAndroid) {
    if (re.data) {
      // var action = re.type;
      // var info = re.data;
      var result = re.data.result;
      if (result == 1) {
        console.log("调取广告成功！");
        advertisingBack(action); // 触发广告回调
      } else {
        console.log("暂无广告资源！");
      }
    } else {
      console.log("暂无安卓 APP回调数据");
    }
  } else if (isIOS) {
    console.log("re.type:", re.type);
    if (re.type) {
      // var action = re.type;
      // var info = re.data;
      var result = re.result;
      if (result == 1) {
        console.log("调取广告成功！");
        advertisingBack(action); // 触发广告回调
      } else {
        console.log("暂无广告资源！");
      }
    } else {
      console.log("暂无IOS APP回调数据");
    }
  }
});

// 刷新用户信息
window.callRefresh = function () {
  window.EventBus.$emit("xysjRefresh");
};

// 视频广告触发回调
function advertisingBack(action) {
  console.log("视频广告触发回调,action:", action);
  window.EventBus.$emit(action);
  // 积分广告回调 action == "AdIntegral"
  // 等级红包广告回调 action == "AdLevelRedBag"
  // 免费获取vip广告回调 action == "AdGetVip"
  // 获取会员点广告回调 action == "AdGetVipPoint"
  // 分红币广告回调 action == "AdFenhongbi"
  // 双倍分红币广告回调 action == "AdDoubleGetFenhongbi"
  // 看广告得宝 action == "AdGoldIngot"
  // 转盘翻倍 action == "WelfareAwd"
  // 逍遥世界广告 action == "XiaoYaoZhiBo"
  // 签到红包 action == "AdSigninRedBag"
  // 新等级红包 action == "AdLevelRedBag_new"
}

// 盒子消息回调
function fromBoxMessage(action) {
  // 刷新sdk侧边栏
  console.log("刷新sdk侧边栏");
  if (action == "RefreshnSdkCenter") {
    window.EventBus.$emit("RefreshPlayerInfo"); // 重新获取玩家等级、区服信息
    window.EventBus.$emit("RefreshLevelBagList_redBag1"); // 红包1重新获取等级红包信息
    window.EventBus.$emit("RefreshLevelBagList_redBag2"); // 红包2重新获取等级红包信息
    window.EventBus.$emit("RefreshLevelBagList_redBag3"); // 红包3重新获取等级红包信息
    window.EventBus.$emit("RefreshFenbiExclusive"); // 专属分红池重新获取配置
  }
}
// 全局过滤器
import * as Filters from "./static/js/filters";
Object.keys(Filters).forEach((key) => Vue.filter(key, Filters[key]));

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});

// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js